import classNames from "classnames"
import OutsideClickHandler from "react-outside-click-handler"

import { Icon, SettingsMenu } from "web/components"
import {
  BarsArrowUpIcon,
  BarsArrowDownIcon,
  LockOpenIcon,
  LockClosedIcon,
  Bars4Icon,
} from "@heroicons/react/24/outline"

export default function ColumnSettings({
  column,
  handleSort,
  handleFrozenFieldChanged,
  onGroup,
  enableFrozenColumns,
  isMenuOpen,
  setIsMenuOpen,
  sortColumn,
  sortDesc,
}) {
  function handleGroup(e) {
    e.stopPropagation()
    onGroup(column.dataKey)
    setIsMenuOpen(false)
  }

  function handleFreeze(e) {
    e.stopPropagation()
    handleFrozenFieldChanged(column)
    setIsMenuOpen(false)
  }

  const options = [
    {
      icon: BarsArrowUpIcon,
      value: "sort_ascending",
      label: "Sort Ascending",
      disabled: sortColumn == column.dataKey && !sortDesc,
      onClick: (e) => {
        handleSort(e, "asc")
        setIsMenuOpen(false)
      },
    },
    {
      icon: BarsArrowDownIcon,
      value: "sort_descending",
      label: "Sort Descending",
      disabled: sortColumn == column.dataKey && sortDesc,
      onClick: (e) => {
        handleSort(e, "desc")
        setIsMenuOpen(false)
      },
    },
    {
      icon: Bars4Icon,
      value: "group",
      label: "Group",
      onClick: handleGroup,
    },
  ]

  if (enableFrozenColumns) {
    options.push({
      icon: column.isFrozen ? LockOpenIcon : LockClosedIcon,
      value: "freeze",
      label: column.isFrozen ? "Unfreeze" : "Freeze",
      onClick: handleFreeze,
    })
  }

  const columnSettingsClasses = classNames(
    "cursor-pointer transition-all duration-200 group-hover/cell:block text-center",
    {
      hidden: !isMenuOpen,
      block: isMenuOpen,
    }
  )

  const columnSortClasses = classNames(
    "group-hover/cell:hidden w-full flex justify-center",
    {
      hidden: isMenuOpen,
      block: !isMenuOpen,
    }
  )

  return (
    <span className="w-8">
      <span className={columnSortClasses}>
        {sortColumn === column.dataKey && (
          <Icon
            width="14px"
            height="14px"
            name={sortDesc ? "arrow-down" : "arrow-up"}
          />
        )}
      </span>
      <span
        className={columnSettingsClasses}
        data-testid={`column_settings_${column.dataKey}`}
      >
        <OutsideClickHandler onOutsideClick={() => setIsMenuOpen(false)}>
          <div onClick={() => setIsMenuOpen(true)}>
            <SettingsMenu menuItems={options} size="tiny" listWidth="w-42" />
          </div>
        </OutsideClickHandler>
      </span>
    </span>
  )
}
